import { IoBarChartSharp } from 'react-icons/io5';
import { FaWpforms } from 'react-icons/fa';
import { ImProfile } from 'react-icons/im';
import { BsCollection } from 'react-icons/bs';

const links = [
  {
    id: 1,
    text: 'stats',
    path: '/',
    icon: <IoBarChartSharp />,
  },
  {
    id: 2,
    text: 'NFT',
    path: 'nft',
    icon: <BsCollection />,
  },
  {
    id: 3,
    text: 'draft',
    path: 'draft',
    icon: <FaWpforms />,
  },
  {
    id: 4,
    text: 'editor',
    path: 'editor',
    icon: <ImProfile />,
  },
];

export default links;
